import styled from 'styled-components';

export const FlowGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const IconChip = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: var(--radius-sm);
  background: #ffffff;
  border: 1px solid var(--border);
  color: var(--stone-700);
`;

export const FlowCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  text-align: left;
  padding: 1.4rem;
  border-radius: var(--radius-md);
  cursor: pointer;
  background: #ffffff;
  border: 1px solid var(--stone-300);
  box-shadow: var(--shadow-sm);
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s;

  strong {
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--foreground);
  }

  span {
    font-size: 0.85rem;
    color: var(--muted-foreground);
    line-height: 1.5;
  }

  &:hover:not(:disabled) {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(255, 188, 3, 0.3),
      0 8px 18px rgba(18, 18, 18, 0.1);
    transform: translateY(-2px);
  }

  /* Tipo de consulta não contratado: continua à vista, mas esmaecido e sem
     reação ao cursor. */
  &:disabled {
    cursor: not-allowed;
    background: var(--stone-50);
    border-color: var(--border);
    box-shadow: none;

    /* O aviso (UnavailableNote) fica de fora: é a linha que precisa ser lida. */
    strong,
    span {
      opacity: 0.6;
    }
  }
`;

/* Aviso do card desabilitado: a opção existe, só não está contratada. */
export const UnavailableNote = styled.small`
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.4;
  color: var(--stone-700);
`;
